import { EVENT_KEYNAMES as e } from "../../common/constants/index.js";
import { configsEqual as t, parseConfig as n, resolveSelector as r, resolveSkipDisabled as i } from "./focusgroup-utils.js";
//#region directives/focusgroup_directive/focusgroup.js
var a = {
	name: "dt-focusgroup-directive",
	install(a) {
		let o = /* @__PURE__ */ new WeakMap();
		a.directive("dt-focusgroup", {
			mounted(e, t) {
				let r = v(e, n(t.value));
				o.set(e, r);
			},
			updated(e, r) {
				let i = n(r.value), a = o.get(e);
				if (a && t(a.config, i)) return;
				y(a, e);
				let s = v(e, i);
				o.set(e, s);
			},
			unmounted(e) {
				y(o.get(e), e), o.delete(e);
			}
		});
		function s(e, t) {
			return Array.from(e.querySelectorAll(t)).filter((t) => {
				if (t.hasAttribute("data-dt-focusgroup-skip") || t.closest("[hidden]")) return !1;
				let n = t.closest("[aria-hidden=\"true\"]");
				return !(n && e.contains(n));
			});
		}
		function c(e) {
			return e.disabled === !0 || e.getAttribute("aria-disabled") === "true";
		}
		function l(e, t, n, r, i) {
			let a = e.length, o = Math.max(0, Math.min(t, a - 1));
			for (let s = 1; s <= a; s++) {
				let l = r ? (t + s * n + a) % a : t + s * n;
				if (l < 0 || l >= a) return o;
				if (!(i && c(e[l]))) return l;
			}
			return o;
		}
		let u = {
			[e.arrowright]: ["horizontal", 1],
			[e.arrowleft]: ["horizontal", -1],
			[e.arrowdown]: ["vertical", 1],
			[e.arrowup]: ["vertical", -1]
		};
		function d(e, t, n) {
			let r = u[e];
			if (!r) return null;
			let [i, a] = r;
			return t === "both" || t === i ? i === "horizontal" && n ? -a : a : null;
		}
		function f(e, t) {
			e.forEach((e, n) => {
				e.setAttribute("tabindex", n === t ? "0" : "-1");
			});
		}
		function p(e, t, n, r, i) {
			f(n, i), t._internalMove = !0, n[i].focus(), queueMicrotask(() => {
				t._internalMove = !1;
			}), t.lastFocusedIndex = i, e.dispatchEvent(new CustomEvent("dt-focusgroup-move", {
				bubbles: !0,
				detail: {
					item: n[i],
					index: i,
					previousItem: n[r],
					previousIndex: r
				}
			}));
		}
		function m(t, n, r) {
			return t === e.home ? l(n, -1, 1, !1, r) : t === e.end ? l(n, n.length, -1, !1, r) : null;
		}
		function h(e, t, n) {
			let r = s(t, n.selector);
			if (!r.length) return;
			let i = r.indexOf(document.activeElement);
			if (i === -1) return;
			let a = m(e.key, r, n.skipDisabled);
			if (a !== null) {
				e.preventDefault(), a !== i && p(t, n, r, i, a);
				return;
			}
			let o = d(e.key, n.config.axis, n.isRTL);
			if (o === null) return;
			e.preventDefault();
			let c = l(r, i, o, n.config.loop, n.skipDisabled);
			c !== i && p(t, n, r, i, c);
		}
		function g(e, t, n) {
			if (n._internalMove) return;
			let r = s(t, n.selector), i = r.indexOf(e.target);
			i !== -1 && (n.lastFocusedIndex = i, f(r, i));
		}
		function _(e, t, n) {
			if (n.config.memory || e.relatedTarget && t.contains(e.relatedTarget)) return;
			let r = s(t, n.selector);
			if (r.length) {
				let e = 0;
				if (n.skipDisabled) {
					let t = r.findIndex((e) => !c(e));
					t !== -1 && (e = t);
				}
				f(r, e), n.lastFocusedIndex = e;
			}
		}
		function v(e, t) {
			let n = r(e, t), a = i(e, t), o = {
				config: t,
				selector: n,
				skipDisabled: a,
				isRTL: getComputedStyle(e).direction === "rtl" || e.closest("[dir]")?.getAttribute("dir") === "rtl",
				lastFocusedIndex: 0,
				_internalMove: !1,
				onKeydown: null,
				onFocusin: null,
				onFocusout: null
			}, l = s(e, n);
			if (!l.length && process.env.NODE_ENV !== "production") {
				let t = e.getAttribute("role");
				console.warn(`[DtFocusgroupDirective] No items found for selector "${n}"` + (t ? ` (inferred from role="${t}")` : "") + ". Check that items match the selector, or provide an explicit selector via v-dt-focusgroup=\"{ selector: '...' }\".");
			}
			if (l.length) {
				let e = 0;
				if (a) {
					let t = l.findIndex((e) => !c(e));
					t !== -1 && (e = t);
				}
				f(l, e);
			}
			return o.onKeydown = (t) => h(t, e, o), o.onFocusin = (t) => g(t, e, o), o.onFocusout = (t) => _(t, e, o), e.addEventListener("keydown", o.onKeydown), e.addEventListener("focusin", o.onFocusin), e.addEventListener("focusout", o.onFocusout), o;
		}
		function y(e, t) {
			e && (e.onKeydown && t.removeEventListener("keydown", e.onKeydown), e.onFocusin && t.removeEventListener("focusin", e.onFocusin), e.onFocusout && t.removeEventListener("focusout", e.onFocusout), e.onKeydown = null, e.onFocusin = null, e.onFocusout = null);
		}
	}
};
//#endregion
export { a as DtFocusgroupDirective, a as default };

//# sourceMappingURL=focusgroup.js.map